// extracted by mini-css-extract-plugin
module.exports = {"tiltFx":"TiltFx_tiltFx__Gvuv5"};